import { combineReducers } from 'redux'
import { RECEIVE_USERS } from '../actions/user-actions.js'
import { RESET_STORE } from '../actions/currentUser-actions'


const userLicenseSearchDashboard = (state = { query: '', results: []}, action) => {
  switch(action.type) {
    case RECEIVE_USERS: return {...state, results: action.results, query: action.query}
    case RESET_STORE: return { query: '', results: []}
    default: return state
  }
}


export default combineReducers( {
  userLicenseSearchDashboard
})
